import React from 'react';
import {observer} from 'mobx-react';
import {Button, InputError} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {t} from 'shared/core';
import CompletedIcon from 'img/list-element-complete@2x.png';
import {ReportDownloadButton} from '../../download';

const ApproveButton = observer(({uiState}) => {
  const {timesheet} = uiState;

  if (timesheet.approved) {
    return (
      <div className='flex align-items-center px2 ml2 border rounded bg-haze' style={{minHeight: 36}}>
        <div className='mr1'>
          <FormattedMessage id='time_tracking.timesheet.Approved'/>
        </div>
        <img src={CompletedIcon} width='18' alt='complete'/>
      </div>
    );
  }

  if (!timesheet.canApprove) return null;

  return (
    <div className='ml2'>
      <Button onClick={() => uiState.approve()}>
        <FormattedMessage id='time_tracking.timesheet.Approve'/>
      </Button>
    </div>
  );
});

const TimesheetActions = observer(({uiState}) => {
  const {payPeriod, employee, errors} = uiState;

  return (
    <div>
      <div className='flex justify-content-end'>
        <ReportDownloadButton
          reportType='timesheet'
          name={t('time_tracking.timesheet.Timesheet')}
          params={{
            payPeriodId: payPeriod.id,
            employeeId: employee.id
          }}
        />
        <ApproveButton uiState={uiState}/>
      </div>
      <div className='flex justify-content-end left-align'>
        <InputError className='inline-block relative nowrap' message={errors.base}/>
      </div>
    </div>
  );
});

export default TimesheetActions;
